export default "__VITE_ASSET__dKZXZ1HF__"